import React, { useRef, useState } from "react";
import {
  Devices,
  CardDevice,
  TitleDevice,
  InfoDevice,
  ImgDevice,
} from "./styles";
import { dataDevices } from "./dispositivos";

const DispositivosApartamentos = () => {
  const devicesRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [dragStartX, setDragStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (event) => {
    setIsDragging(true);
    setDragStartX(event.clientX - devicesRef.current.offsetLeft);
    setScrollLeft(devicesRef.current.scrollLeft);
  };

  const handleMouseMove = (event) => {
    if (!isDragging) return;
    const x = event.clientX - devicesRef.current.offsetLeft;
    const scrollX = x - dragStartX;
    devicesRef.current.scrollLeft = scrollLeft - scrollX;
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  return (
    <Devices
      ref={devicesRef}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseLeave}
    >
      <CardDevice>
        <div style={{ display: "flex", gap: "2rem", alignItems: "center", padding: ".3rem .5rem" }}>
          <ImgDevice src={dataDevices.hid.imagem} />
          <TitleDevice>{dataDevices.hid.name}</TitleDevice>
        </div>
        <InfoDevice>Dispositivos: {dataDevices.hid.info}</InfoDevice>
      </CardDevice>

      <CardDevice>
        <div style={{ display: "flex", gap: "2rem", alignItems: "center", padding: ".3rem .5rem" }}>
          <ImgDevice src={dataDevices.sensorgas.imagem} />
          <TitleDevice>{dataDevices.sensorgas.name}</TitleDevice>
        </div>
        <InfoDevice>Dispositivos: {dataDevices.sensorgas.info}</InfoDevice>
      </CardDevice>
      <CardDevice>
        <div style={{ display: "flex", gap: "2rem", alignItems: "center", padding: ".3rem .5rem" }}>
          <ImgDevice src={dataDevices.hidrometro.imagem} />
          <TitleDevice>{dataDevices.hidrometro.name}</TitleDevice>
        </div>
        <InfoDevice>Dispositivos: {dataDevices.hidrometro.info}</InfoDevice>
      </CardDevice>
      <CardDevice>
        <div style={{ display: "flex", gap: "2rem", alignItems: "center", padding: ".3rem .5rem" }}>
          <ImgDevice src={dataDevices.tecladoporta.imagem} />
          <TitleDevice>{dataDevices.tecladoporta.name}</TitleDevice>
        </div>
        <InfoDevice>Dispositivos: {dataDevices.tecladoporta.info}</InfoDevice>
      </CardDevice>

    </Devices>
  );
};

export default DispositivosApartamentos;
